import React from 'react';
import styles from './title.module.scss';
import clsx from 'clsx';

type TitleVariants = 'h1' | 'h2';

type TitleProps = {
  title: string;
  className?: string;
  variant?: TitleVariants;
  hasCobranding?: boolean;
  maintainSize?: boolean;
};

export const Title = ({
  title,
  className,
  hasCobranding = false,
  maintainSize = false,
}: TitleProps) => {
  const marginBottomClass = hasCobranding ? `mb-40` : 'mb-80';

  return (
    <h1
      className={clsx(
        className,
        styles[marginBottomClass],
        `${maintainSize ? styles.staticTitle : styles.title}`
      )}
    >
      {title}
    </h1>
  );
};
